import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as actions from "../../../store/users/actions";
import TableGridView from "../../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import { withStyles } from "@material-ui/styles";
import Switch from '@material-ui/core/Switch';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';

const MySwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: "#FFF",
      '& + $track': {
        backgroundColor: '#24D7D3',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#24D7D3',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 22,
    height: 22,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const InternalUsers = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [searchValues, setSearchValues] = useState({});
  const lang = localStorage.getItem("lang") || "en";
  const { internalUsers, usersStatistics } = useSelector((state) => state.users);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [blockConfirmation, setBlockConfirmation] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  useEffect(() => {
    //Get internal Users list
    dispatch(
      actions?.internalUsersRequest({
        page: 1,
        roleId: -1,
        sort: "created_at,desc",
      })
    );
    dispatch(actions?.usersStatisticsRequest());
    return () => {
      dispatch(actions.internalUsersReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //table n grid view render
  const headings = [
    messages.users.code,
    messages.users.user_name,
    messages.users.position,
    messages.users.email,
    messages.users.mobile,
    messages.users.status,
    messages.users.actions,
  ];

  const renderTableData = () => {
    return internalUsers?.data?.map((user, i) => {
      const {
        username,
        phone_number,
        role_name,
        name,
        email,
        is_blocked,
      } = user;
      return [
        username,
        name,
        role_name,
        email,
        <span className="phoneNum">{phone_number}</span>,
        <MySwitch checked={!is_blocked} name="block" onChange={() => {
          if (!is_blocked) {
            setSelectedUser(user);
            setBlockConfirmation(true);
          } else {
            dispatch(actions.unblockUserRequest(user.id));
          }
        }} />,
        <div className="actions-icons">
          <EditRoundedIcon onClick={() => history.push(`/users/internal/edit/${user.id}`)} />
          <DeleteForeverRoundedIcon onClick={() => {
            setSelectedUser(user);
            setDeleteConfirmation(true);
          }}/>
        </div>,
      ];
    });
  };

  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.internalUsersRequest({
        page,
        sort: "created_at,desc",
        ...searchValues,
      })
    );
  };

  return (
    <>
      {internalUsers ? (
        <div style={{ padding: '5px 0'}}>
          <button className={`myBtn ${lang === 'ar' && 'rtl'}`} 
              onClick={(e) => {e.preventDefault(); history.push("/users/internal/add")}} >
              <AddCircleOutlineOutlinedIcon />{messages.users.add_user}
          </button>
          <TableGridView
            title={
              <>
                <FormattedMessage
                  values={{
                    total: internalUsers?.total,
                    totals: usersStatistics?.internal_users,
                  }}
                  id="users.user_of"
                  defaultMessage={messages.users.users_of}
                />
              </>
            }
            Form={<Filterform setSearchValues={setSearchValues} />}
            table={{
              stickyHeader: true,
              headings: headings,
              data: renderTableData(),
              headClass: "bg-white table-head",
              noData: messages.noData.no_data,
            }}
            //gridView={renderGridView}
            pagination={{
              count: internalUsers.last_page,
              page: internalUsers.current_page,
              handleChange: handlePageChange,
            }}
          />
        </div>
      ) : null}
  
      <ConfirmDialog show={deleteConfirmation} 
                     onCancel={() => {
                        setDeleteConfirmation(false)
                      }}
                     onConfirm={() => {
                      if (internalUsers?.data?.length === 1) {
                          dispatch(actions.deleteUserRequest(selectedUser.id))
                          handlePageChange(null, internalUsers.current_page - 1);
                      } else {
                          dispatch(actions.deleteUserRequest(selectedUser.id))
                      }
                        setDeleteConfirmation(false);
                     }}
                     content={messages.users.delete_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />

      <ConfirmDialog show={blockConfirmation} 
                     onCancel={() => {
                        setBlockConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.blockUserRequest(selectedUser.id));
                        setBlockConfirmation(false);
                     }}
                     content={messages.users.block_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
    </>
  );
};

export default injectIntl(InternalUsers);
